<script>
import { mapActions, mapGetters } from "vuex";

import sizeVue from "@/mixins/size.vue";
import AdminEducationLanguageAdd from "../../components/modals/AdminEduLangAdd.vue";

export default {
  components: { AdminEducationLanguageAdd },

  data: () => ({
    isLoading: false,

    options: {},
    totalItemsCount: 0,
    itemsPerPage: 50,
    rowsPerPage: [25, 50, 100],

    search: null,

    isAddModal: false,

    selected: {},
  }),

  mixins: [sizeVue],

  computed: {
    tableHeight: (vm) => vm.size.height - 280,

    ...mapGetters("admin-education-languages", ["GET_EDUCATION_LANGUAGES"]),
    items: (vm) => vm.GET_EDUCATION_LANGUAGES,
  },

  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions("admin-education-languages", [
      "INIT_EDUCATION_LANGUAGES",
      "EDUCATION_LANGUAGE_STATUS",
    ]),

    getItems() {
      if (this.isLoading) return;
      this.isLoading = true;

      this.options.search = this.search;

      this.INIT_EDUCATION_LANGUAGES(this.options).then((totalItemsCount) => {
        this.totalItemsCount = totalItemsCount;
        this.isLoading = false;
      });
    },

    onAddModel() {
      this.selected = {};

      this.$nextTick(() => {
        this.isAddModal = true;
      });
    },

    onEdit({ item = {} }) {
      this.selected = item;

      this.$nextTick(() => {
        this.isAddModal = true;
      });
    },

    onSwitch({ item = {} }) {
      if (this.isLoading) return;

      this.isLoading = false;
      this.EDUCATION_LANGUAGE_STATUS(item).then(() => {
        this.isLoading = false;
        this.$nextTick(() => {
          this.getItems();
        });
      });
    },
  },
};
</script>

<template>
  <v-container fluid>
    <admin-education-language-add
      v-if="isAddModal"
      @close="isAddModal = false"
      @refresh="getItems"
      :data="selected"
    />

    <v-card class="pa-5">
      <div class="d-flex pb-5">
        <div class="title" v-text="$t('Education languages')" />
        <v-spacer />
        <v-btn @click="onAddModel">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn :loading="isLoading" @click="getItems" class="ml-5">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-text-field
          :placeholder="$t('Izlash...')"
          append-icon="mdi-magnify"
          v-model="search"
          dense
          hide-details
          outlined
          clearable
          class="search-input ml-5"
          style="max-width: 320px;"
          @click:append="getItems"
          @keyup.enter="getItems"
          @click:clear="getItems"
        />
      </div>

      <v-data-table
        :mobile-breakpoint="0"
        :height="tableHeight"
        :loading="isLoading"
        :headers="[
          {
            text: '№',
            value: 'row-number',
            width: 20,
            sortable: false,
          },
          {
            text: $t('Name uz'),
            value: 'name->uz',
          },
          {
            text: $t('Name ru'),
            value: 'name->ru',
          },
          {
            text: $t('Name en'),
            value: 'name->en',
          },
          {
            text: '',
            value: 'edit',
            width: 20,
            sortable: false,
          },
          {
            text: '',
            value: 'block',
            width: 20,
            sortable: false,
          },
        ]"
        fixed-header
        :items="items"
        :options.sync="options"
        :server-items-length="totalItemsCount"
        item-key="id"
        :items-per-page="itemsPerPage"
        :footer-props="{ itemsPerPageOptions: rowsPerPage }"
        class="elevation-0"
      >
        <template v-slot:body="props">
          <tbody>
            <tr :key="item.id" v-for="(item, index) in props.items">
              <td v-text="index + 1" />
              <td v-text="item.names.uz" />
              <td v-text="item.names.ru" />
              <td v-text="item.names.en" />
              <td
                v-ripple
                @click="onEdit({ item })"
                class="cursor-pointer px-2"
              >
                <v-icon :title="$t('Edit')"> mdi-pencil </v-icon>
              </td>
              <td @click="onSwitch({ item })" class="pr-0">
                <v-switch
                  :loading="isLoading"
                  hide-details
                  class="mt-0"
                  v-model="item.active"
                  inset
                />
              </td>
            </tr>
            <tr v-if="!props.items.length && !isLoading">
              <td :colspan="props.headers.length + 1" class="text-center py-4">
                {{ $t("No data") }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style lang="scss" scoped>
::v-deep .search-input {
  .v-input__slot {
    background: #f1f5f9 !important;
    border-radius: 10px !important;
    min-height: 38px !important;
  }
  fieldset { border-color: transparent !important; }
  &:hover fieldset { border-color: #d0d5dd !important; }
  &.v-input--is-focused fieldset { border-color: #00274c !important; border-width: 1.5px !important; }
  .v-icon { color: #94a3b8 !important; font-size: 20px !important; }
  input { font-size: 14px; }
  input::placeholder { color: #94a3b8 !important; }
}
::v-deep .search-input.theme--dark {
  .v-input__slot { background: #22232e !important; }
  fieldset { border-color: transparent !important; }
  &:hover fieldset { border-color: #33354a !important; }
  &.v-input--is-focused fieldset { border-color: #ffd451 !important; }
  .v-icon { color: #606275 !important; }
  input { color: #d5d6de !important; }
  input::placeholder { color: #606275 !important; }
}
</style>
